import { motion } from 'framer-motion';

export default function AboutUs() {
  return (
    <section className="relative py-24 px-6 bg-gradient-to-br from-indigo-900 via-purple-900 to-black text-white overflow-hidden">

      {/* Animated Glow Blobs */}
      <motion.div
        className="absolute top-0 left-0 w-96 h-96 bg-indigo-500 opacity-20 blur-3xl rounded-full -z-10"
        animate={{ x: [0, 50, -30, 0], y: [0, -30, 50, 0] }}
        transition={{ duration: 20, repeat: Infinity }}
      />
      <motion.div
        className="absolute bottom-0 right-0 w-80 h-80 bg-purple-600 opacity-20 blur-2xl rounded-full -z-10"
        animate={{ x: [0, -40, 20, 0], y: [0, 30, -40, 0] }}
        transition={{ duration: 25, repeat: Infinity }}
      />

      <motion.div
        className="max-w-4xl mx-auto text-left"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        {/* Heading */}
        <motion.h2
          className="text-4xl font-extrabold mb-10 font-orbitron tracking-tight text-center"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2 }}
        >
          About Us
        </motion.h2>

        {/* Intro */}
        <motion.p
          className="text-lg mb-10 leading-relaxed font-raleway text-gray-100 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <strong>The Prisu Experts</strong> is a forward-thinking data solutions company dedicated to fueling the next generation of artificial intelligence and machine learning. We specialize in delivering tailored, multilingual, and culturally contextual data that drives intelligent systems to be more fair, inclusive, and impactful.
        </motion.p>

        {/* Mission */}
        <motion.div
          className="mb-10"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <h3 className="text-2xl font-bold mb-2 text-white">Our Mission</h3>
          <p className="text-lg leading-relaxed text-gray-200 font-raleway">
            To empower AI innovation by providing high-quality, diverse, and ethically sourced data — helping organizations build smarter, more empathetic technologies that serve humanity better.
          </p>
        </motion.div>

        {/* Vision */}
        <motion.div
          className="mb-10"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <h3 className="text-2xl font-bold mb-2 text-white">Our Vision</h3>
          <p className="text-lg leading-relaxed text-gray-200 font-raleway">
            To be recognized as the world’s most reliable partner in AI training data — enabling global companies to create intelligent systems that truly understand and connect with people from every walk of life.
          </p>
        </motion.div>

        {/* Core Values */}
        <motion.div
          className="mb-10"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h3 className="text-2xl font-bold mb-2 text-white">Our Core Values</h3>
          <ul className="list-disc pl-5 text-lg leading-relaxed text-gray-200 font-raleway space-y-2">
            <li>🌐 Diversity & Inclusion</li>
            <li>✅ Accuracy & Quality</li>
            <li>🧠 Innovation & Agility</li>
            <li>🔒 Ethics & Data Security</li>
            <li>🤝 Client Collaboration & Trust</li>
          </ul>
        </motion.div>

        {/* Global Impact */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h3 className="text-2xl font-bold mb-2 text-white">A Global Team, A Global Impact</h3>
          <p className="text-lg leading-relaxed text-gray-200 font-raleway">
            With a global network of linguists, data specialists, and domain experts, Prisu Experts supports clients across industries — from tech and healthcare to finance and retail — helping them scale AI projects with speed, precision, and integrity.
          </p>
        </motion.div>
      </motion.div>
    </section>
  );
}
